module.exports = __webpack_public_path__ + "img/prize-graphic.cbcae862.png";